module.exports = __webpack_public_path__ + "static/github-0eee8229a901dc5cc729575220a93822.png";